<script lang="ts">
    const linksOnPage = document.querySelectorAll<HTMLSpanElement>(
        "span.link[data-url]"
    );
    for (let i = 0; i < linksOnPage.length; i++) {
        let link = linksOnPage.item(i);
        link.addEventListener("click", () => {
            const url = link.dataset["url"];
            if (url) {
                window.open(url, "_blank");
            }
        });
    }
</script>
